import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../pages/Home.vue";
import Contato from "../pages/Contato.vue";
import IsoQuality from "../pages/IsoQuality.vue";
import Products from "../pages/Products.vue";
import Grades from "../pages/Grades.vue";
import Degraus from "../pages/Degraus.vue";
import Gradis from "../pages/Gradis.vue";
import NotFoundComponent from "../pages/NotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/contato",
    name: "Contato",
    component: Contato,
  },
  {
    path: "/iso-quality",
    name: "IsoQuality",
    component: IsoQuality,
  },

  {
    path: "/products",
    name: "Products",
    component: Products,
  },
  {
    path: "/grades",
    name: "Grades",
    component: Grades,
  },
  {
    path: "/degraus",
    name: "Degraus",
    component: Degraus,
  },

  {
    path: "/gradis",
    name: "Gradis",
    component: Gradis,
  },
  { path: "*", component: NotFoundComponent },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
